var _mask, _path, _path2, _mask2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudio = function SvgStudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 38"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "studio_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 28.43a.43.43 0 0 1 .43-.43h5.14a.43.43 0 0 1 .43.43v8.141a.43.43 0 0 1-.429.429H18.43a.43.43 0 0 1-.429-.429z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 28.43c0-.79.64-1.43 1.43-1.43h5.14c.79 0 1.43.64 1.43 1.43L23 29h-4zM24 37h-6zm-5.571 0c-.79 0-1.429-.64-1.429-1.429V28.43c0-.79.64-1.43 1.43-1.43l.57 2v8zm5.141-10c.79 0 1.43.64 1.43 1.43v7.141c0 .79-.64 1.429-1.429 1.429H23v-8z",
    mask: "url(#studio_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M25 9 12.5 19.929v17.357h24.857V19.714z"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "studio_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 27,
    y: 21,
    rx: 0.383
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 27,
    y: 21,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#studio_svg__b)",
    rx: 0.383
  })));
};
export default SvgStudio;